/*
*  妥妥递有些参数需要AES加密
 */
import CryptoJS from 'crypto-js'

const urlKey="aef9e7ba9c680934";
const urlIv="7a69ece002cb28e0";

const utf8Parse = (str) => {
  return CryptoJS.enc.Utf8.parse(str);
}
const aesEncode = (str,key,iv) => {
   const result = CryptoJS.AES.encrypt(utf8Parse(str),utf8Parse(key),{
    mode:CryptoJS.mode.CBC,
    padding:CryptoJS.pad.Pkcs7,
    iv: utf8Parse(iv),
  }).toString();

  return result;
}
const base64 = (str) => CryptoJS.enc.Base64.stringify(utf8Parse(str)).toString();

export const cryptoEncode = (str) => base64(aesEncode(str, urlKey, urlIv))